/* eslint-disable camelcase */
import * as yup from 'yup';
import { Schema } from 'yup';

export interface SendingOrderCreate {
  date_id?: number | undefined;
  product_id?: number | undefined;
  color: boolean;
  customer?: string | null | undefined;
  message?: string | undefined;
  createdByName: string;
  createdByEmail: string;
}

export const SendingOrderCreateSchema: Schema<SendingOrderCreate> = yup.object().shape({
  date_id: yup.number().required('Måste anges').typeError('Måste välja datum'),
  product_id: yup.number().optional(), // TODO: fix later
  color: yup.boolean().required('Måste anges'),
  customer: yup.string().optional(),
  message: yup.string().optional(),
  createdByName: yup.string().required('Måste anges!'),
  createdByEmail: yup.string().email().required('Måste anges!'),
});
